import { CheckinCard } from '../journal/JournalCard';
import { HelperBeeCard } from '../helper-bee/HelperBeeCard';
import { ResourcesCard } from '../resources/ResourcesCard';
import { TipCard } from './TipCard';

export const CaregiverTools: React.FC = () => {
    return (
        <>
            <CheckinCard />
            <HelperBeeCard />
            <ResourcesCard />
            <TipCard />
        </>
    );
};
